import React, { useState, useEffect } from 'react';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { getMenuConfig, compare } from '../../utils/menuNavigationHelper';
import * as storage from '../../utils/storage';
import { IsEnglish } from '../../utils/language';
import { isIOS } from '../../utils';
import * as keyMenu from '../../scripts/KeyMenu';

const useStyles = makeStyles(theme => ({
    bottomNavigation: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'var(--color2)',
        boxShadow: '1px 20px 10px 15px',
        zIndex: 11002,
        display: 'table',
        width: '100%'
    },
    bottomNavigationIOS: {
        height: '70px'
    },
    bottomButton: {
        height: '54px',
        width: '54px',
        color: 'var(--color4)',
        minWidth: '72px !important',
        marginTop: '3px',
        '& > span > span.MuiBottomNavigationAction-label': {
            fontSize: '0.65rem',
            fontWeight: 'bold'
        },
        '& > span > span.MuiBottomNavigationAction-label.Mui-selected': {
            fontSize: '0.65rem !important',
            fontWeight: 'bold'
        }
    },
}));



function MenuNavigationFavorite(props) {
    const classes = useStyles();
    const [value, setValue] = useState(keyMenu.MENU_HOME);
    const [menus, setMenus] = useState([]);
    const [qtyMenus, setQtyMenus] = useState(4);
    const [isiOS, setIsIOS] = useState(isIOS());

    useEffect(() => {
        loadMenu();
    }, []);

    useEffect(() => {
        setValue(props.selectedMenu);
    }, [props.selectedMenu]);

    useEffect(() => {
        if (!props.showAllMenu) {
            setValue(localStorage.getItem('knkmob.selectedMenu'));
        }
    }, [props.showAllMenu]);

    const loadMenu = () => {
        let menus = storage.getMenu();
        menus = JSON.parse(menus).filter(x => !x.isTab);

        let menusFormatted = [];

        if (menus) {
            menus.forEach(item => {
                const menuConfig = getMenuConfig(item.codeMenu);
                menusFormatted.push({ item, menuConfig });
            });

            // Sort by priority
            menusFormatted = menusFormatted.sort(compare);

            // Get specific quantity menus
            menusFormatted = menusFormatted.slice(0, qtyMenus);
            setMenus(menusFormatted);
        }
    }

    const handleBottomNavigation = (path) => {
        if (path === "plus") {
            setValue(path);
            props.handleCloseAllMenu(false);
            setTimeout(() => {
                props.handleShowAllMenu(true);
            }, 0);
            return;
        }
        localStorage.setItem('knkmob.selectedMenu', path);
        props.handleSelectedPage(path)
        props.handleCloseAllMenu(true);
        props.handleShowAllMenu(false);
        setValue(path);
    }

    return (
        <BottomNavigation
            id={"menuFavorite"}
            showLabels
            className={`${classes.bottomNavigation} ${isiOS && classes.bottomNavigationIOS}`}
            value={value}
            onChange={(event, newValue) => {
                handleBottomNavigation(newValue);
            }}
        >
            {menus && menus.map((obj, index) =>
                <BottomNavigationAction
                    key={index}
                    className={classes.bottomButton}
                    label={obj.menuConfig.getThisDesc ? (IsEnglish() ? obj.menuConfig.descriptionE : obj.menuConfig.descriptionF) : (IsEnglish() ? obj.item.descriptionEnglish : obj.item.descriptionFrench)}
                    value={obj.menuConfig.id} icon={obj.menuConfig.iconNoColor}
                />
            )}
            <BottomNavigationAction className={classes.bottomButton} label="Plus" value="plus" icon={<MoreVertIcon />} />
        </BottomNavigation>
    );
}

export default withNamespaces(['login'], { wait: true })(MenuNavigationFavorite);